<ng-container *ngIf="status === true">
  <span class="badge badge-primary font-md align-self-end text-white"
        [translate]="successTransKey">Saved</span>
</ng-container>
<ng-container *ngIf="status === false">
  <span class="badge badge-danger font-md align-self-end text-white"
        [translate]="errorTransKey">Error</span>
</ng-container>